import CartModalController from 'emun.cart/cart-modal.controller.es6'

class ShippingRatePickerController extends CartModalController {
    constructor($session, $cart, $uibModalInstance, options) {
        'ngInject';
        super($session, $cart, $uibModalInstance, options); // TODO: options?
    }

    select(shippingRate) {
        let $ctrl = this;
        $ctrl.picker.selecting.notify(shippingRate);
        return $ctrl.$cart.applyShippingRate(shippingRate).then(res => {
            $ctrl.$close(res);
            $ctrl.picker.selected.notify(res);
        });
    }
    submit(shippingRate) {
        let $ctrl = this;
        $ctrl.select(shippingRate);
    }
}

function ShippingRatePickerFactory($cart, $q, modals, AutoQuery) {
    'ngInject';
    class ShippingRatePicker extends AutoQuery {
        constructor(options) {
            if(!options) options = {};
            let b2c = $cart.businessModel === 'Retail';
            let purchaserType = b2c ? 'Consumer' : 'Retailer';
            let url = `QueryPaymentMethods/${$cart.businessModel}/${$cart.purchaser.id || 0}.json?JsConfig=ExcludeDefaultValues&Fields=${options.fields || options.selectFields || '*'}`;
            let aqOptions = angular.extend({ url, autoLoad: false, append: false, take: 100 }, options);
            super(aqOptions);
            let picker = this;
            ['editing', 'creating', 'selecting', 'selected', 'deleting', 'deleted'].forEach(k => {
                picker[k] = $q.defer();
                picker[k].on = picker[k].subscribe = picker[k].sub = cb => picker[k].promise.finally(null, cb);
            });
            //picker.loaded.subscribe(() => {
            //    if (b2c) picker.results.forEach(r => r.personName = {full:r.name});
            //    else picker.results.forEach(r => r.id = r.token);
            //})
        }
        open(current) {
            let picker = this;
            if (!current) current = $cart.shippingMethod;
            let modalInstance = picker.modal = modals.open({
                size: 'lg',
                templateUrl: 'shipping-rate-picker.html',
                controller: ShippingRatePickerController,
                bindToController: true,
                controllerAs: '$ctrl',
                resolve: {
                    options: () => { return { current, picker, query: picker } }
                }
            });

            return modalInstance.result;
        }
    }
    return ShippingRatePicker;
}

function ShippingRatePickerDirectiveFactory(ShippingRatePicker, $parse) {
    return {
        scope: false,
        link: function (scope, element, attr) {
            let picker = new ShippingRatePicker(scope.$eval(attr.autoQueryOptions));
            let fieldName = attr.ngModel || attr.shippingRatePicker || attr.shippingRatePicker || 'shippingRatePicker';
            picker.linkDirective(scope, attr);
            fieldName && $parse(fieldName).assign(scope, picker);

            var $targets = (attr.clickSelector ? element.find(attr.clickSelector) : element);
            $targets.on('click', e => picker.open(scope.$eval(attr.current)));
        }
    }
}

angular.module('emun.cart')
    .factory('ShippingRatePicker', ShippingRatePickerFactory)
    .directive('shippingRatePicker', ShippingRatePickerDirectiveFactory);